import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'hoverGallery',
  setup(__props) {

const hoverEffect1 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect1.vue"))
const hoverEffect2 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect2.vue"))
const hoverEffect3 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect3.vue"))
const hoverEffect4 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect4.vue"))
const hoverEffect5 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect5.vue"))
const hoverEffect6 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect6.vue"))
const hoverEffect7 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect7.vue"))
const hoverEffect8 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect8.vue"))
const hoverEffect9 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect9.vue"))
const hoverEffect10 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect10.vue"))
const hoverEffect11 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect11.vue"))
const hoverEffect12 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect12.vue"))
const hoverEffect13 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect13.vue"))
const hoverEffect14 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect14.vue"))
const hoverEffect15 = defineAsyncComponent(() => import("@/components/theme/gallery/hover/hoverEffect15.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Gallery",
      title: "Image Hover Effects"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(hoverEffect1)),
      _createVNode(_unref(hoverEffect2)),
      _createVNode(_unref(hoverEffect3)),
      _createVNode(_unref(hoverEffect4)),
      _createVNode(_unref(hoverEffect5)),
      _createVNode(_unref(hoverEffect6)),
      _createVNode(_unref(hoverEffect7)),
      _createVNode(_unref(hoverEffect8)),
      _createVNode(_unref(hoverEffect9)),
      _createVNode(_unref(hoverEffect10)),
      _createVNode(_unref(hoverEffect11)),
      _createVNode(_unref(hoverEffect12)),
      _createVNode(_unref(hoverEffect13)),
      _createVNode(_unref(hoverEffect14)),
      _createVNode(_unref(hoverEffect15))
    ])
  ], 64))
}
}

})